<div class="fullModal opened iframe-modal-container" id="IframModalComponent">
  <div class="title" style="filter: brightness(50%)">
    <span>Service Preview</span>
  </div>
  <div class="subtitle">
    <span>Below you should see the "Hello World" splash page, accessed via your private service &#64;</span>
  </div>
  <div class="subtitle">
    @if (!isSample) {
      <span><b>https://demo.tools.netfoundry.io</b></span>
    }
    @if (isSample) {
      <span><b>https://sample.tools.netfoundry.io</b></span>
    }
  </div>
  <div class="subtitle bottom">
    <span
      >*If the preview doesn't load, please make sure that your Ziti tunneler is running and your endpoint is
      enrolled.</span
      >
    </div>
    <div (click)="hide()" class="buttonBall close" id="EscZEndpointClose">
      <div class="buttonLabel">ESC</div>
    </div>
    @if (connected) {
      <iframe [src]="safeUrl" class="iframe-container"></iframe>
    }
    @if (!connected) {
      <div class="iframe-placeholder"></div>
    }
    @if (!connected) {
      <app-loading-indicator [isLoading]="true"></app-loading-indicator>
    }
    <div class="row buttonRow right" style="margin-top: 1.25rem">
      <button (click)="refreshIframe()" class="save" id="IFrameReloadButton">Reload</button>
      <button (click)="return()" class="save" id="IFrameReturnButton">Close</button>
    </div>
  </div>
